import { NavigationContainer as NavContainer } from '@react-navigation/native';
import { navigationRef } from './RootNavigation';
import { setVisibilityAsync, setBehaviorAsync } from 'expo-navigation-bar';
import { PropsWithChildren } from 'react';
import { reactNavigationIntegrationForSentry } from '..';
import { IS_ANDROID } from '@/utils/platform';
import { logError } from '@/utils/logHandling';

// Wrapper for the native NavigationContainer from react-navigation that gets a children prop
const EXERCISE_ROUTES = [
  'AufgabenExercise',
  'AufgabenExerciseText',
  'BildKartenExercise',
];

const showNavigationBar = async () => {
  try {
    await setVisibilityAsync('visible');
  } catch (e: any) {
    logError('Failed to show navigation bar', e);
  }
};

const hideNavigationBar = async () => {
  try {
    await setVisibilityAsync('hidden');
    await setBehaviorAsync('overlay-swipe');
  } catch (e: any) {
    logError('Failed to hide navigation bar', e);
  }
};

export function NavigationContainer({ children }: PropsWithChildren) {
  return (
    <NavContainer
      onReady={() => {
        reactNavigationIntegrationForSentry.registerNavigationContainer(
          navigationRef,
        );
      }}
      onStateChange={(state) => {
        if (!IS_ANDROID || !state) {
          return;
        }
        const { routes } = state;
        const activeRoute = routes[routes.length - 1];
        const isExercisePage = EXERCISE_ROUTES.includes(
          activeRoute?.name ?? '',
        );
        if (!isExercisePage) {
          return showNavigationBar();
        }
        hideNavigationBar();
      }}
      ref={navigationRef}
    >
      {children}
    </NavContainer>
  );
}
